import React from 'react';

const Login = React.lazy(() => import('../pages/Login'));
const Register = React.lazy(() => import('../pages/Register'));
const ForgetPassword = React.lazy(() => import('../pages/ForgetPassword'));
const RecoverPassword = React.lazy(() => import('../pages/RecoverPassword'));

export default [
  { path: '/', Component: Login },
  { path: '/login', Component: Login },
  { path: '/cadastro', Component: Register },
  { path: '/esquecisenha', Component: ForgetPassword },
  { path: '/alterarsenha/:token', Component: RecoverPassword },
  { path: '*', Component: Login },
];
